import { createIcon } from '@chakra-ui/react'

const IconFolder = createIcon({
  displayName: 'IconFolder',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
    />
  )
})

export default IconFolder
